// Static config for the Create/Edit Event modal — map settings and a
// fallback cover image used when the host doesn't upload one.

// Re-exported from the shared loader module so every Google Maps consumer
// (this modal, the event-view map, the venue-onboarding modal) shares the
// same array reference and the @react-google-maps/api dedupe works.
export { GOOGLE_LIBRARIES } from "../../../lib/googleMaps";

export const MAP_CONTAINER_STYLE = {
  width: "100%",
  height: "160px",
  borderRadius: "12px",
};

export const MAP_OPTIONS = {
  streetViewControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
};

// Partner venues confirm based on a revenue deadline. Tickets must cover
// the minimum at least this many hours before the event's start time.
export const CONFIRMATION_LEAD_HOURS = 5;

// Default initial form data for a brand new event.
export const DEFAULT_FORM_DATA = {
  cost: 0,
  maxMembers: 10,
  online: false,
  showAdd: true,
};

// Used when the host submits without uploading a cover image.
export const DEFAULT_EVENT_IMAGE =
  "https://images.pexels.com/photos/776654/pexels-photo-776654.jpeg?auto=compress&cs=tinysrgb&h=350";
